import request from "@/utils/request";

// 实时通知-通知列表
export function noticeListApi(data) {
    return request({
        url: "/admin/notice",
        method: "get",
        params: data
    });
}

//实时通知-添加通知
export function addNoticeApi(data) {
    return request({
        url: "/admin/notice",
        method: "post",
        data
    });
}

// 实时通知-修改通知 - 获取
export function getFixNoticeApi(data) {
    return request({
        url: "/admin/notice/" + data.id,
        method: "get",
        params: data
    });
}

// 实时通知-修改通知 - 提交
export function putFixNoticeApi(data) {
    return request({
        url: "/admin/notice/" + data.id,
        method: "put",
        data
    });
}

// 实时通知-删除通知
export function deleteNoticeApi(data) {
    return request({
        url: "/admin/notice/" + data.id,
        method: "delete",
        data
    });
}

// 实时通知-通知记录
export function logNoticeApi(data) {
    return request({
        url: "/admin/notice_log",
        method: "get",
        params: data
    });
}

//置顶/取消置顶
export function toppingNoticeApi(data) {
    return request({
        url: "/admin/set_top_rank",
        method: "post",
        data
    });
}

// 实时通知 - 获取通知列表下拉框类型
export function getSelectListApi() {
    return request({
        url: "/admin/get_notice_list_select",
        method: "get"
    });
}

// 实时通知 - 获取通知用户列表
export function getAdminListApi() {
    return request({
        url: "/admin/get_notice_admin_select",
        method: "get",
    });
}

// 实时通知 - 发送通知
export function sendNoticeApi(data) {
    return request({
        url: "/admin/send_notice",
        method: "post",
        data
    });
}

// 实时通知-查看阅读记录
export function showNoticeLogApi(data) {
    return request({
        url: "/admin/show_notice_receipt_log/" + data.id,
        method: "get",
        params: data
    });
}
